import React, {useContext, useState, useEffect, useRef} from 'react';
import { useNavigate } from "react-router-dom";

import './app.scss';
import {Content, Loading} from '@carbon/react';


import Home from './content/Home';
import Footer from './components/Footer';

import {Route, Routes} from 'react-router-dom';
import ViewManagers from './content/ViewManagers/ViewManagers';
import ViewDepartments from './content/ViewDepartments/ViewDepartments';
import ViewProjects from './content/ViewProjects/ViewProjects';
import ViewCommodities from './content/ViewCommodities/ViewCommodities';
import ApproversList from './content/ApproversList/ApproversList';
import UniqueExpenditure from './content/UniqueExpenditure/UniqueExpenditure';
import TaxCondition from './content/TaxCondition/TaxCondition';
import ApproversDelegation from './content/ApproversDelegation/ApproversDelegation';
import DocumentsDeletion from './content/DocumentsDeletion/DocumentsDeletion';
import AttachmentsAdmin from './content/AttachmentsAdmin/AttachmentsAdmin';
import OperationsLog from './content/OperationsLog/OperationsLog';
import FollowUpLog from './content/FollowUpLog/FollowUpLog';
import ValidationLog from './content/ValidationLog/ValidationLog';
import RTVLog from './content/RTVLog';
import IdsWithError from './content/IdsWithError';
import DocumentView from './content/DocumentView/DocumentView';
import Login from './content/Login';


import { getKernelIasResources } from "./services/services";
import MinimalDocumentView from './content/MinimalDocumentView';
import SsoLogin from './content/SsoLogin';


function App() {

  const navigate = useNavigate();
  const [isTestEnviroment, setIsTestEnviroment] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const messageResponse = useRef([]);  
  //for modal error or information use
  const [messageModal, setMessageModal] = useState('');
  const [reloadRequest,setReloadRequest] = useState(false);

  //start controller error modal
  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  // This function will be called only once after the initial render
  const requestVerifyEnviromentIsActive = useRef(false);
  const verifyTestEnviroment = () => {
    if(requestVerifyEnviromentIsActive.current) {return}
    requestVerifyEnviromentIsActive.current = true;
    getKernelIasResources()
    .then(function (result) {
      if(result.status === 200){
        result.json()
        .then(result => {          
          setIsLoading(false);
          setIsTestEnviroment(result.testEnviroment);
          
        })
      }else if(result.status === 410)   {
        result.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        result.text()
          .then(response => {            
            openMessageModal(response);
          })
      }
      requestVerifyEnviromentIsActive.current = false;
    })
    .catch(error => {
      requestVerifyEnviromentIsActive.current = false;
      console.log("Error in api /kernelIAs/isTestEnviroment: " + error)      
      setReloadRequest(true);
    });
  };

  useEffect(() => {
    verifyTestEnviroment();    
  }, []);

  useEffect(() => {
    verifyTestEnviroment();
  },[reloadRequest])
  
  if(isLoading){
    <Loading className={'Loading'} withOverlay={true} />
  }else{
    return (
      <>     
      
        {isTestEnviroment &&
          <Routes>
            <Route path="/" element={<Login />} />
          </Routes>
        }
        
        { !isTestEnviroment && 
          <Routes>
            <Route path="/" element={<SsoLogin />} />
          </Routes>
        }
        
       <>          
          <Content style={{ minHeight: "100vh" }}>
            <Routes>
              <Route path="/sso-login" element={<SsoLogin />} />
              
              <Route path="/home" element={<Home />} />
              <Route path="/view-managers" element={<ViewManagers />} />
              <Route path="/view-departments" element={<ViewDepartments />} />
              <Route path="/view-projects" element={<ViewProjects />} />
              <Route path="/view-commodities" element={<ViewCommodities />} />
              <Route path="/view-approvers-list" element={<ApproversList />} />
              <Route path="/unique-expenditure" element={<UniqueExpenditure />} />
              <Route path="/tax-condition" element={<TaxCondition />} />
              <Route path="/approvers-delegation" element={<ApproversDelegation />} />
              <Route path="/documents-deletion" element={<DocumentsDeletion />} />
              <Route path="/minimal-document-view" element={<MinimalDocumentView />} />
              <Route path="/attachments-admin" element={<AttachmentsAdmin />} />
              <Route path="/operations-log" element={<OperationsLog />} />
              <Route path="/follow-up-log" element={<FollowUpLog />} />
              <Route path="/validation-log" element={<ValidationLog />} />
              <Route path="/rtv-log" element={<RTVLog />} />
              <Route path="/ids-with-error" element={<IdsWithError />} />
              <Route path="/document-view" element={<DocumentView />} />
            </Routes>
          </Content>
          </>
        <Footer />
          
      </>
    );
  }
  
};

export default App;
